import React from 'react';
import ErrorPage from 'components/ErrorPage';
import { ERROR_TYPES } from 'components/ErrorPage/constants';

const NotFoundPage = () => (<ErrorPage type={ERROR_TYPES.NOT_FOUND} />);

export { NotFoundPage };
export default NotFoundPage;
